import { useLocation } from "react-router-dom";

export const useIsOnMmmPage = () => {
  const { pathname } = useLocation();
  return pathname.includes("/mmm");
};
